import { Component, OnInit, ViewChild } from '@angular/core';
import { FlowService } from '../../_services/flow.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { MultiSelect } from 'primeng/multiselect';
declare var $: any;

@Component({
  selector: 'app-create-flow-popup',
  templateUrl: './create-flow-popup.component.html',
  styleUrls: ['./create-flow-popup.component.scss']
})
export class CreateFlowPopupComponent implements OnInit {

  grades = [];
  selectedGrades = [];
  allGrades = [];

  flowStagesFlags = [true, false, false, false, false];
  editFlag = false;
  saveBtnFlag = false;
  currLang;
  @ViewChild('multiSelectFlow') multiSelect: MultiSelect;
  constructor(private flowService: FlowService,
    private dataService: DataService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private errorMsgService: ErrorMsgService,
    private amplitudesService: AmplitudeService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    $(document).on('hidden.bs.modal', '#add-flow-popup', () => {
      this.selectedGrades = [];
      this.flowStagesFlags = [true, false, false, false, false];
    })

    this.dataService.getGrades().subscribe((grades: any) => {

      
    this.flowService.getFlowData().subscribe(res => {
      
      if (res !== null) {
        this.selectedGrades = [];
        this.flowStagesFlags = [true, false, false, false, false];
        this.editFlag = false;
        if (res["name"]) {
          this.setData(res);
          this.editFlag = true;
          this.saveBtnFlag = true;
        }        
        $("#add-flow-popup").modal('show');
        // this.dataService.getGrades().subscribe((grades: any) => {
        //   if (res != null) {
        //   }
        //   this.grades = grades;
        // });
      }
      else {
        this.editFlag = false;
      }
      
      if (grades != null) {
        this.grades = grades;
        this.allGrades = grades?.map(grade=> ({
          value:grade.id,
          label:grade.name
        }));

      }
    });
    });

  }
  setData(data) {
    data.grades.forEach(element => {
      this.selectedGrades.push(element.id);
    });
    if (data.name.startsWith('P')) {
      this.flowStagesFlags[0] = true;
    }
    if (data.name.includes('T')) {
      this.flowStagesFlags[1] = true;
    }
    if (data.name.includes('S')) {
      this.flowStagesFlags[2] = true;
    }
    if (data.name.includes('G')) {
      this.flowStagesFlags[3] = true;
    }
    if (data.name.endsWith('P')) {
      this.flowStagesFlags[4] = true;
    }
  }
  gradeSelectted(event) {
    // to make the dropdown still opened 
    this.multiSelect.show();
    event?.originalEvent?.stopPropagation();
    this.selectedGrades = event.value;
    this.saveBtnFlag = this.flowStagesFlags.lastIndexOf(true) != 0 && event.length != 0 ? true : false;
    this.amplitudesService.trackEvent('Select.Flow_Grades_Dropdown',{})
  }
  changeStageState(index) {
    this.flowStagesFlags[index] = !this.flowStagesFlags[index];

    this.saveBtnFlag = this.flowStagesFlags.lastIndexOf(true) != 0 && this.selectedGrades.length != 0 ? true : false;
    this.amplitudesService.trackEvent('Select.Flow_Order',{})
  }
  getFlowString() {
    let flowString = "";

    flowString += this.flowStagesFlags[0] ? "P" : "";
    flowString += this.flowStagesFlags[1] ? "T" : "";
    flowString += this.flowStagesFlags[2] ? "S" : "";
    flowString += this.flowStagesFlags[3] ? "G" : "";
    flowString += this.flowStagesFlags[4] ? "P" : "";

    return flowString;
  }

  saveFlow() {
    this.amplitudesService.trackEvent('Save.Dismissal_Flow',{})
    const mode = this.editFlag ? 'sync' : 'append';
    let body: any = {
      grades_ids: this.selectedGrades,
      flow: this.getFlowString(),
      mode
    }
    this.flowService.assignGradesToFlow(body).subscribe(res => {
      $("#add-flow-popup").modal('hide');
      this.flowService.changeReloadFlag(true);
    },
      err => {
        $("#add-flow-popup").modal('hide');
        const errorMsg = this.convertErrorMsgAsString(err.error.errors);
        this.errorMsgService.setMessage(errorMsg);
      });
  }
  convertErrorMsgAsString(err) {
    if (err.flow) {
      return err.flow[0];
    }
    let errorMsg = "";
    err.forEach(element => {
      errorMsg += element.name + ", ";
    });
    errorMsg += `${this.translate.instant('dismissal-flow.add-flow.missing-data-error')}`;
    return errorMsg;
  }
}